import { type Plugin } from '@segment/analytics-next'
import { SEGMENT_BRAND, SEGMENT_DEPLOYABLE_NAME, segmentAdsTimestamps } from '@nwwp/utils'

export const defaultParametersPlugin = (): Plugin => {
  return {
    name: 'default-parameters',
    type: 'enrichment',

    isLoaded: () => true,
    load: () => Promise.resolve(),

    page: (ctx) => {
      Object.entries(getDefaultParameters()).forEach(([key, value]) => {
        ctx.updateEvent(key, value)
      })

      return ctx
    },

    track: (ctx) => {
      Object.entries(getDefaultParameters()).forEach(([key, value]) => {
        ctx.updateEvent(key, value)
      })

      return ctx
    },
  }
}

const getDefaultParameters = () => {
  const { ads_timestamp, ads_timestamp_unix } = segmentAdsTimestamps()
  return {
    'properties.brand': SEGMENT_BRAND,
    'properties.deployable_name': SEGMENT_DEPLOYABLE_NAME,
    'properties.deployable_version': '1.0.0',
    'properties.segment_source': 'browser',
    'properties.ads_timestamp': ads_timestamp,
    'properties.ads_timestamp_unix': ads_timestamp_unix,
  }
}
